import { Controller } from "@hotwired/stimulus"

// Coordinates the two-level written-confirmation picker. Keeping the method
// and "Other" panels under one controller ensures a hidden parent can never
// have a nested input re-enabled by an independent visibility controller.
export default class extends Controller {
  static targets = ["method", "methodPanel", "otherPanel"]

  connect() {
    this.update()
  }

  update() {
    const selectedMethod = this.methodTargets.find((input) => input.checked)?.value

    this.methodTargets.forEach((input) => {
      input.setAttribute("aria-expanded", String(input.checked))
    })
    this.methodPanelTargets.forEach((panel) => {
      this.setPanelState(panel, panel.dataset.method === selectedMethod)
    })
    this.otherPanelTargets.forEach((panel) => {
      const methodSelected = panel.dataset.method === selectedMethod
      const methodPanel = this.methodPanelTargets.find((candidate) => candidate.dataset.method === panel.dataset.method)
      const otherChoice = methodPanel?.querySelector('input[value="other"]')
      const visible = methodSelected && otherChoice?.checked === true

      if (otherChoice) otherChoice.setAttribute("aria-expanded", String(visible))
      this.setPanelState(panel, visible)
    })
  }

  setPanelState(panel, visible) {
    panel.hidden = !visible
    panel.querySelectorAll("input, select, textarea").forEach((input) => {
      input.disabled = !visible
    })
  }
}
